import classnames from "classnames";
import React from "react";
import styles from "./Divider.module.scss";

export interface DividerProps {
  className?: string;
  useCustomMargin?: boolean;
}

const Divider = ({ className, useCustomMargin = true }: DividerProps) => {
  return (
    <hr
      className={classnames(
        styles.root,
        className,
        useCustomMargin && styles.customMargin
      )}
      aria-hidden
    />
  );
};

export default Divider;
